const styles = () => ({
  syncAlertContainer: {
    margin: '0 40px 5px',
    borderRadius: 7,
    boxShadow:
      'inset 0px 0px 0px 1px rgb(225, 233, 240), 0px 1px 2px 0px rgba(0, 0, 0, 0.05)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'column',
    overflow: 'hidden',
  },
});

export default styles;
